import { render, staticRenderFns } from "./TransferCommodityFromWarehouse.vue?vue&type=template&id=03bf18c2&scoped=true&"
import script from "./TransferCommodityFromWarehouse.vue?vue&type=script&lang=js&"
export * from "./TransferCommodityFromWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./TransferCommodityFromWarehouse.vue?vue&type=style&index=0&id=03bf18c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf18c2",
  null
  
)

export default component.exports